import { useState, useEffect } from 'react';
import Logo from '../images/logo-white.png';
export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { label: 'Home', href: '#home' },
    { label: 'Sobre', href: '#sobre' },
    { label: 'Transporte', href: '#transporte' },
    { label: 'Contato', href: '#contato' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 nav-blur
        ${scrolled ? 'bg-white/90 shadow-sm py-3' : 'bg-transparent py-5'}`}
    >
      <div className="max-w-5xl mx-auto px-5 flex items-center justify-between">
        {/* Logo */}
        <a href="#home" className="flex items-center gap-2">
          {/* Placeholder diamond logo */}
          <div className="leading-tight">
              <img
                src={Logo}
                alt="Logo Campos Transportes"
                className="relative w-full object-contain drop-shadow-2xl"
                style={{ maxHeight: '50px' }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className={`gold-link font-body text-sm font-medium transition-colors duration-200
                ${scrolled ? 'text-brand-dark hover:text-brand-green' : 'text-brand-dark hover:text-brand-green'}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="https://wa.me/11946384844"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-slide ml-2 border border-brand-green text-brand-green text-sm font-medium px-5 py-2 rounded-sm transition-colors duration-300"
          >
            Cotação
          </a>
        </nav>

        {/* Mobile hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden flex flex-col gap-1.5 p-1"
          aria-label="Menu"
        >
          <span className={`block w-6 h-0.5 bg-brand-dark transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-6 h-0.5 bg-brand-dark transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-6 h-0.5 bg-brand-dark transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden transition-all duration-300 overflow-hidden bg-white/95 nav-blur
        ${menuOpen ? 'max-h-80 border-t border-gray-100' : 'max-h-0'}`}>
        <nav className="flex flex-col px-5 py-4 gap-4">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setMenuOpen(false)}
              className="font-body text-base font-medium text-brand-dark hover:text-brand-green transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="https://wa.me/11946384844"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-slide w-full text-center border border-brand-green text-brand-green font-medium px-5 py-2.5 rounded-sm"
          >
            Cotação
          </a>
        </nav>
      </div>
    </header>
  );
}
